
import { Component, Prop, Vue } from 'vue-property-decorator';
import GreyBoxForm from '@/components/utils/PopulateForms/components/GreyBoxForm.vue';
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import ScheduleHeader from '@/components/utils/PopulateForms/components/ScheduleHeader.vue';
import { schedule3AboutOrderInfoType } from '@/types/Application/ProtectionOrder/PDF';

@Component({
    components: {
        UnderlineForm,
        GreyBoxForm,
        CheckBox,
        ScheduleHeader
    }
})
export default class Schedule3 extends Vue {

    @Prop({ required: true })
    result!: any;

    dataReady = false;
    aboutOrder = {} as schedule3AboutOrderInfoType;

    mounted() {
        this.dataReady = false;
        this.getAboutOrder();
        this.dataReady = true;
    }

    public getAboutOrder() {

        this.aboutOrder = { dateOfPO: '', inCourtForPO: '', whyNotInCourt: '', kindOfParty: [], whyTerminatePO: '' };

        if (this.result?.aboutSurvey) {
            const about = this.result.aboutSurvey;
            this.aboutOrder.dateOfPO = about.terminateDateOfPO;
            this.aboutOrder.inCourtForPO = about.inCourtForPO;
            this.aboutOrder.whyNotInCourt = about.inCourtForPO == 'n' ? about.whyNotInCourt : '';
            this.aboutOrder.kindOfParty = about.kindofPartyIbPO ? about.kindofPartyIbPO : [];
            this.aboutOrder.whyTerminatePO = about.whyTerminatePO;
        }
    }

}
